import React, { useEffect} from "react";
import useActionableListStore from "modules/dashboards/actionable_list/store";
import Actionables from "modules/dashboards/actionables";

function ActionableList({tab}) {
  const {
    tempEngData,
    todayEngData,
    tempLoading,
    todayLoading,
    fetchTempEngData,
    fetchTodayEngData,
  } = useActionableListStore();

  useEffect(() => {
    if(tab=="actionable"){
      fetchTodayEngData();
      fetchTempEngData();
    }
  }, [tab]);

  const sortedData = (data) => {
    return data.sort((customerA, customerB) => {
      const [dateA, timeA] = customerA.reminder_date.split("T");
      const [dateB, timeB] = customerB.reminder_date.split("T");

      if (dateB.localeCompare(dateA) > 0) {
        return 1;
      } else if (dateB.localeCompare(dateA) < 0) {
        return -1;
      } else {
        return timeA.localeCompare(timeB);
      }
    });
  };

  return (
    <div>
      <Actionables
        tempEngData={tempEngData}
        tempLoading={tempLoading}
        todayLoading={todayLoading}
        todayEngData={sortedData(todayEngData)}
        tab={tab}
      />
    </div>
  );
}

export default ActionableList;